import { IAdvInfo } from '../types/advantageInterface';
import { advHomeImport, advThemeImport, advSearchImport, advBlogImport } from './advInfoImageImport';

const [cart, money, surfaces, chat] = advHomeImport;
const [laptop, devices, speed, update, browsers, setup] = advThemeImport;
const [fast, target, cart2, laptop2] = advSearchImport;
const [layout, social, details, next] = advBlogImport;

export const advInfoHome: IAdvInfo[] = [
  {
    advName: 'Conversion-Driven Functionality',
    advDescr: `Engineered with conversion-focused tools and seamless performance to drive sales and improve customer experience.`,
    advLogo: speed,
    advAlt: 'Conversion-Driven Functionality',
  },
  {
    advName: 'Sales-Focused Design',
    advDescr:
      'Themes featuring refined design elements to deliver a cohesive, user-friendly experience that drives revenue.',
    advLogo: cart,
    advAlt: 'Sales-Focused Design',
  },
  {
    advName: 'Customization Options',
    advDescr:
      'User-friendly customization tools let you personalize your store for strong brand consistency and customer engagement.',
    advLogo: surfaces,
    advAlt: 'Customization Options',
  },
  {
    advName: 'One-of-a-Kind Support',
    advDescr:
      'Get expert support on business days, even during your trial. We typically respond within 15 minutes during support hours.',
    advLogo: chat,
    advAlt: 'One-of-a-Kind Support',
  },
];

export const advInfoFull: IAdvInfo[] = [
  {
    advName: 'User-Friendly Design',
    advDescr: `Made with a user-friendly design at its core, our theme’s intuitive interface simplifies navigation and drives your sales.`,
    advLogo: laptop,
    advAlt: 'Design',
  },
  {
    advName: 'Responsive & Mobile-Optimized',
    advDescr: `Smooth shopping experience across all devices, from desktops to smartphones. We guarantee customer satisfaction and improved site's reach.`,
    advLogo: devices,
    advAlt: 'Responsive and Mobile-Optimized',
  },
  {
    advName: 'Customization Options',
    advDescr:
      'Equipped with adaptable features and customization tools, the theme can be adjusted to capture the identity of your brand.',
    advLogo: surfaces,
    advAlt: 'Customization Options',
  },
  {
    advName: 'Fast Loading Times',
    advDescr:
      'Quick loading times to keep your visitors engaged, reduce bounce rates and contribute to your website’s visibility in search engine results.',
    advLogo: speed,
    advAlt: 'Fast Loading Times',
  },
  {
    advName: 'Regular Updates',
    advDescr: `Improvements and updates delivered regularly, ensuring a smooth, secure, and efficient operation of your site.`,
    advLogo: update,
    advAlt: 'Regular Updates',
  },
  {
    advName: 'Cross-Browser Compatibility',
    advDescr:
      'Your online store will look great and operate smoothly and seamlessly across various web browsers.',
    advLogo: browsers,
    advAlt: 'Cross-Browser Compatibility',
  },
  {
    advName: 'Easy to Set Up',
    advDescr:
      'Our theme allows you to create an professional-looking online store with no coding, making setup seamlessly simple.',
    advLogo: setup,
    advAlt: 'Easy to Set Up',
  },
  {
    advName: 'Reliable Support Team',
    advDescr:
      'Exceptional assistance whenever you need it. We are here to answer any questions, resolve issues, and offer guidance.',
    advLogo: chat,
    advAlt: 'Support',
  },
];

export const advBlogFull: IAdvInfo[] = [
  {
    advName: 'Structured Layout',
    advDescr: `Organize your blog with a clear layout so readers find content quickly and stay longer.`,
    advLogo: layout,
    advAlt: 'Layout',
  },
  {
    advName: 'Social Media Sharing',
    advDescr: `Enable easy sharing on social media to attract more visitors and grow your audience.`,
    advLogo: social,
    advAlt: 'Social',
  },
  {
    advName: 'Informative Details',
    advDescr:
      'Show post date, author, and tags to add credibility and help users explore related topics.',
    advLogo: details,
    advAlt: 'Details',
  },
  {
    advName: 'Read Next Suggestions',
    advDescr:
      'Suggest related posts to encourage deeper browsing and increase time on site.',
    advLogo: next,
    advAlt: 'Read Next',
  },
];


export const advSearchFull: IAdvInfo[] = [
  {
    advName: 'Fast Product Discovery',
    advDescr: `Help customers quickly find products by enabling fast, precise search results that match their needs.`,
    advLogo: fast,
    advAlt: 'Fast Product Discovery',
  },
  {
    advName: 'Boost Sales & Conversions',
    advDescr: `Increase sales by guiding shoppers directly to the items they want, reducing friction in the buying process.`,
    advLogo: target,
    advAlt: 'Boost Sales',
  },
  {
    advName: 'Organized Product Catalog',
    advDescr:
      'Easily manage your inventory with searchable tags, categories, and filters that keep products well organized.',
    advLogo: cart2,
    advAlt: 'Product Catalog',
  },
  {
    advName: 'Lower Bounce Rates',
    advDescr:
      'Keep visitors engaged by making it simple to find exactly what they’re looking for, reducing site exits.',
    advLogo: laptop2,
    advAlt: 'Rates',
  },
];

export const advFeaturesFull: IAdvInfo[] = [
  {
    advName: 'High-Speed Performance',
    advDescr: `Optimized for speed and reliability to keep your store running flawlessly at any volume.`,
    advLogo: speed,
    advAlt: 'Performance',
  },
  {
    advName: 'Immersive Design & Effects',
    advDescr: `Designed with immersive visuals — promo blocks, scroll effects, parallax, and fade-ins.`,
    advLogo: surfaces,
    advAlt: 'Design',
  },
  {
    advName: 'Powerful Sales Features',
    advDescr: 'Packed with sales-driven features like filtering, countdowns, markers, popups, and more.',
    advLogo: money,
    advAlt: 'Sales',
  },
  {
    advName: 'Built for Big Catalogs',
    advDescr:
      'Built for growing businesses with wide-ranging products and categories.',
    advLogo: cart,
    advAlt: 'Built',
  },
];
